<template>
  <div class="page-wrapper">
    <div class="page-breadcrumb">
      <div class="row">
        <div class="col-md-12 col-lg-12 align-self-center">
          <ul class="breadcrumb mb-2 list-style-none">
            <li
              class="breadcrumb-item h6 font-16 mylink"
              style="margin-right: 3rem"
            >
              <router-link class="mylink" to="profile">{{
                $t("per_prof")
              }}</router-link>
            </li>
            <li
              class="breadcrumb-item h6 font-16 mylink"
              v-show="profile.role !== 'staff'"
              style="margin-right: 3rem"
            >
              <router-link class="mylink" to="businessprofile">{{
                $t("biz_prof")
              }}</router-link>
            </li>
            <li
              class="breadcrumb-item h6 font-16 mylink"
              style="margin-right: 3rem"
            >
              <router-link class="mylink" to="changepassword">{{
                $t("change_pwd")
              }}</router-link>
            </li>
            <li
              class="breadcrumb-item h6 font-16 mylink"
              style="margin-right: 3rem"
            >
              <router-link class="mylink" to="chart-settings">{{
                $t("chart_settings")
              }}</router-link>
            </li>
            <li
              class="breadcrumb-item h6 font-16 mylink"
              style="margin-right: 3rem"
            >
              <router-link class="mylink" to="decommissioned-devices">{{
                $t("decommissioned_devices")
              }}</router-link>
            </li>

            <!-- <li
              v-show="profile.role !== 'staff'"
              class="breadcrumb-item h6 font-16 mylink"
            >
              <router-link class="mylink" to="developers">{{
                $t("devs")
              }}</router-link>
            </li> -->
          </ul>
        </div>
      </div>
    </div>

    <router-view />

    <footer class="footer text-center">
      &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Settings",
  data() {
    return {
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    ...mapGetters(["profile"]),
  },
};
</script>

<style scoped>
.mylink {
  color: #213e7a !important;
  font-size: 14px !important;
  text-decoration-color: #213e7a !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-color: #213e7a !important;
}
.router-link-exact-active.router-link-active {
  text-decoration: underline !important;
  color: #213e7a !important;
  cursor: default;
  text-underline-offset: 5px;
}
</style>

<i18n>
{
	"en": {
		"biz_prof": "Business Profile",
		"change_pwd": "Change Password",
		"devs": "Developers",
		"per_prof": "Personal Profile"
	},
	"es": {
		"biz_prof": "Perfil de trabajo",
		"change_pwd": "Cambia la contraseña",
		"devs": "Desarrolladores",
		"per_prof": "Perfil personal"
	},
	"fr": {
		"biz_prof": "Profil de l'entreprise",
		"change_pwd": "Changer le mot de passe",
		"devs": "Développeurs",
		"per_prof": "Profil personnel"
	},
	"sw": {
		"biz_prof": "Profaili ya Biashara",
		"change_pwd": "Badilisha neno la siri",
		"devs": "Watengenezaji",
		"per_prof": "Wasifu wa Kibinafsi"
	}
}
</i18n>
